import React, {useCallback, useEffect, useId, useRef, useState} from 'react';
import {Box, Typography} from '@mui/material';

// Рекламный блок РСЯ с подписью «Реклама», схлопыванием, если реклама не загрузилась, и (необязательно) обновлением по времени.
// refreshSeconds > 0 — блок перерисовывается раз в столько секунд, ТОЛЬКО пока он виден на экране (≥50% площади) и вкладка активна:
// обновление невидимых блоков снижает видимость и доверие рекламодателей. По правилам РСЯ обновлять можно не чаще раза в 30 секунд,
// поэтому меньше 30 мы не принимаем. Блок не ставим вплотную к кнопкам — рядом должен оставаться отступ (см. margin).
const MIN_REFRESH_SECONDS = 30;

const AdSlot = ({blockId, minHeight = 100, refreshSeconds = 0, type, sx, hidden = false}) => {
    const containerId = `yandex_rtb_${blockId}_${useId().replace(/:/g, '')}`;
    const wrapperRef = useRef(null);
    const visibleRef = useRef(false);
    const [collapsed, setCollapsed] = useState(false);

    const render = useCallback(() => {
        window.yaContextCb = window.yaContextCb || [];
        window.yaContextCb.push(() => {
            if (window.Ya && window.Ya.Context && window.Ya.Context.AdvManager) {
                window.Ya.Context.AdvManager.render({blockId, renderTo: containerId, ...(type ? {type} : {})});
            }
        });
    }, [blockId, containerId, type]);

    useEffect(() => {
        render();
    }, [render]);

    // Пустое место без рекламы (блокировщик, нет показа) убираем.
    useEffect(() => {
        const timer = setTimeout(() => {
            const el = document.getElementById(containerId);
            if (el && el.childElementCount === 0) setCollapsed(true);
        }, 4000);
        return () => clearTimeout(timer);
    }, [containerId]);

    // Видимость блока на экране.
    useEffect(() => {
        const el = wrapperRef.current;
        if (!el || typeof IntersectionObserver === 'undefined') return undefined;
        const observer = new IntersectionObserver(([entry]) => {
            visibleRef.current = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        }, {threshold: [0, 0.5, 1]});
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!refreshSeconds) return undefined;
        const seconds = Math.max(refreshSeconds, MIN_REFRESH_SECONDS);
        const timer = setInterval(() => {
            const el = document.getElementById(containerId);
            if (!el || el.childElementCount === 0) return; // пока ничего не показано — обновлять нечего
            if (!visibleRef.current || document.visibilityState !== 'visible') return;
            el.innerHTML = '';
            render();
        }, seconds * 1000);
        return () => clearInterval(timer);
    }, [refreshSeconds, containerId, render]);

    return (
        <Box ref={wrapperRef} sx={{width: '100%', minHeight: collapsed ? 0 : minHeight, display: hidden ? 'none' : 'block', ...sx}}>
            {!collapsed && <Typography variant="caption" color="text.disabled" sx={{display: 'block', mb: 0.5, fontSize: 10, letterSpacing: '0.06em', textTransform: 'uppercase'}}>Реклама</Typography>}
            <Box id={containerId} sx={{width: '100%', minHeight: collapsed ? 0 : minHeight - 16}}/>
        </Box>
    );
};

export default AdSlot;
